/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GroupAccount,
  GroupCollectionsListParams,
  GroupCompanyReportsDashboard,
  GroupCompanyReportsDashboardRetrieveParams,
  GroupCompanyReportsListParams,
  GroupFoodAndDrinkListParams,
  GroupMainDashboard,
  GroupOrganizationsListParams,
  GroupPackagingListParams,
  GroupProductsListParams,
  GroupPurchasesDashboardRetrieveParams,
  GroupPurchasingDashboard,
  GroupUsersListParams,
  PaginatedGroupCollectionListList,
  PaginatedGroupCompanyReportListList,
  PaginatedGroupFoodDrinkList,
  PaginatedGroupOrganizationListList,
  PaginatedGroupPackagingList,
  PaginatedGroupProductListList,
  PaginatedGroupUserList
} from '../../types'
import { apiClient } from '../../client';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Group account details for the authenticated parent organisation.
 */
export const groupAccountRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<GroupAccount>(
      {url: `/group/account/`, method: 'GET', signal
    },
      options);
    }
  

export const getGroupAccountRetrieveQueryKey = () => {
    return [`/group/account/`] as const;
    }

    
export const getGroupAccountRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupAccountRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupAccountRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupAccountRetrieve>>> = ({ signal }) => groupAccountRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupAccountRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupAccountRetrieve>>>
export type GroupAccountRetrieveInfiniteQueryError = unknown

export const useGroupAccountRetrieveInfinite = <TData = Awaited<ReturnType<typeof groupAccountRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupAccountRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupAccountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof groupAccountRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupAccountRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupAccountRetrieve>>> = ({ signal }) => groupAccountRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof groupAccountRetrieve>>>
export type GroupAccountRetrieveQueryError = unknown

export const useGroupAccountRetrieve = <TData = Awaited<ReturnType<typeof groupAccountRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupAccountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List collections across the parent's selected child organizations.

Filters by `organizations` (no date filter). Each row carries a product
count and average emissions intensity pre-computed in the materialised view.
 */
export const groupCollectionsList = (
    params?: GroupCollectionsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupCollectionListList>(
      {url: `/group/collections/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupCollectionsListQueryKey = (params?: GroupCollectionsListParams,) => {
    return [`/group/collections/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupCollectionsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupCollectionsList>>, TError = unknown>(params?: GroupCollectionsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCollectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCollectionsList>>> = ({ signal, pageParam }) => groupCollectionsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCollectionsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupCollectionsList>>>
export type GroupCollectionsListInfiniteQueryError = unknown

export const useGroupCollectionsListInfinite = <TData = Awaited<ReturnType<typeof groupCollectionsList>>, TError = unknown>(
 params?: GroupCollectionsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCollectionsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupCollectionsListQueryOptions = <TData = Awaited<ReturnType<typeof groupCollectionsList>>, TError = unknown>(params?: GroupCollectionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCollectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCollectionsList>>> = ({ signal }) => groupCollectionsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCollectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof groupCollectionsList>>>
export type GroupCollectionsListQueryError = unknown

export const useGroupCollectionsList = <TData = Awaited<ReturnType<typeof groupCollectionsList>>, TError = unknown>(
 params?: GroupCollectionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCollectionsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List company reports across the parent's selected child organizations.

Filters by `organizations` (csv of child org uuids) and an end-date
window (`dateStart`, `dateEnd`). All scope rollups and totals are pre-computed
in the materialised view.
 */
export const groupCompanyReportsList = (
    params?: GroupCompanyReportsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupCompanyReportListList>(
      {url: `/group/company-reports/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupCompanyReportsListQueryKey = (params?: GroupCompanyReportsListParams,) => {
    return [`/group/company-reports/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupCompanyReportsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupCompanyReportsList>>, TError = unknown>(params?: GroupCompanyReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCompanyReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCompanyReportsList>>> = ({ signal, pageParam }) => groupCompanyReportsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCompanyReportsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupCompanyReportsList>>>
export type GroupCompanyReportsListInfiniteQueryError = unknown

export const useGroupCompanyReportsListInfinite = <TData = Awaited<ReturnType<typeof groupCompanyReportsList>>, TError = unknown>(
 params?: GroupCompanyReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCompanyReportsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupCompanyReportsListQueryOptions = <TData = Awaited<ReturnType<typeof groupCompanyReportsList>>, TError = unknown>(params?: GroupCompanyReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCompanyReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCompanyReportsList>>> = ({ signal }) => groupCompanyReportsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCompanyReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof groupCompanyReportsList>>>
export type GroupCompanyReportsListQueryError = unknown

export const useGroupCompanyReportsList = <TData = Awaited<ReturnType<typeof groupCompanyReportsList>>, TError = unknown>(
 params?: GroupCompanyReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCompanyReportsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Aggregated company reports dashboard: scope totals, emissions time-series, per-org breakdown, and scope 3 category split.
 */
export const groupCompanyReportsDashboardRetrieve = (
    params?: GroupCompanyReportsDashboardRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<GroupCompanyReportsDashboard>(
      {url: `/group/company-reports-dashboard/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupCompanyReportsDashboardRetrieveQueryKey = (params?: GroupCompanyReportsDashboardRetrieveParams,) => {
    return [`/group/company-reports-dashboard/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupCompanyReportsDashboardRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError = unknown>(params?: GroupCompanyReportsDashboardRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCompanyReportsDashboardRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>> = ({ signal, pageParam }) => groupCompanyReportsDashboardRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCompanyReportsDashboardRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>>
export type GroupCompanyReportsDashboardRetrieveInfiniteQueryError = unknown

export const useGroupCompanyReportsDashboardRetrieveInfinite = <TData = Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError = unknown>(
 params?: GroupCompanyReportsDashboardRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCompanyReportsDashboardRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupCompanyReportsDashboardRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError = unknown>(params?: GroupCompanyReportsDashboardRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupCompanyReportsDashboardRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>> = ({ signal }) => groupCompanyReportsDashboardRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupCompanyReportsDashboardRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>>
export type GroupCompanyReportsDashboardRetrieveQueryError = unknown

export const useGroupCompanyReportsDashboardRetrieve = <TData = Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError = unknown>(
 params?: GroupCompanyReportsDashboardRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupCompanyReportsDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupCompanyReportsDashboardRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Group headline KPIs, year-by-year emissions time-series, and product breakdown by emissions rating.
 */
export const groupDashboardRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<GroupMainDashboard>(
      {url: `/group/dashboard/`, method: 'GET', signal
    },
      options);
    }
  

export const getGroupDashboardRetrieveQueryKey = () => {
    return [`/group/dashboard/`] as const;
    }

    
export const getGroupDashboardRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupDashboardRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupDashboardRetrieve>>> = ({ signal }) => groupDashboardRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupDashboardRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupDashboardRetrieve>>>
export type GroupDashboardRetrieveInfiniteQueryError = unknown

export const useGroupDashboardRetrieveInfinite = <TData = Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupDashboardRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupDashboardRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupDashboardRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupDashboardRetrieve>>> = ({ signal }) => groupDashboardRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupDashboardRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof groupDashboardRetrieve>>>
export type GroupDashboardRetrieveQueryError = unknown

export const useGroupDashboardRetrieve = <TData = Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupDashboardRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Cross-org Food & Drink aggregation table.
 */
export const groupFoodAndDrinkList = (
    params?: GroupFoodAndDrinkListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupFoodDrinkList>(
      {url: `/group/food-and-drink/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupFoodAndDrinkListQueryKey = (params?: GroupFoodAndDrinkListParams,) => {
    return [`/group/food-and-drink/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupFoodAndDrinkListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError = unknown>(params?: GroupFoodAndDrinkListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupFoodAndDrinkListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupFoodAndDrinkList>>> = ({ signal, pageParam }) => groupFoodAndDrinkList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupFoodAndDrinkListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupFoodAndDrinkList>>>
export type GroupFoodAndDrinkListInfiniteQueryError = unknown

export const useGroupFoodAndDrinkListInfinite = <TData = Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError = unknown>(
 params?: GroupFoodAndDrinkListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupFoodAndDrinkListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupFoodAndDrinkListQueryOptions = <TData = Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError = unknown>(params?: GroupFoodAndDrinkListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupFoodAndDrinkListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupFoodAndDrinkList>>> = ({ signal }) => groupFoodAndDrinkList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupFoodAndDrinkListQueryResult = NonNullable<Awaited<ReturnType<typeof groupFoodAndDrinkList>>>
export type GroupFoodAndDrinkListQueryError = unknown

export const useGroupFoodAndDrinkList = <TData = Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError = unknown>(
 params?: GroupFoodAndDrinkListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupFoodAndDrinkList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupFoodAndDrinkListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List the requesting parent organization's child organizations with summary counts.

Drives the Organisations table on the group dashboard. Each row exposes
pre-computed user / report / purchased-good / product counts from the
materialised view.
 */
export const groupOrganizationsList = (
    params?: GroupOrganizationsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupOrganizationListList>(
      {url: `/group/organizations/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupOrganizationsListQueryKey = (params?: GroupOrganizationsListParams,) => {
    return [`/group/organizations/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupOrganizationsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupOrganizationsList>>, TError = unknown>(params?: GroupOrganizationsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupOrganizationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupOrganizationsList>>> = ({ signal, pageParam }) => groupOrganizationsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupOrganizationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupOrganizationsList>>>
export type GroupOrganizationsListInfiniteQueryError = unknown

export const useGroupOrganizationsListInfinite = <TData = Awaited<ReturnType<typeof groupOrganizationsList>>, TError = unknown>(
 params?: GroupOrganizationsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupOrganizationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupOrganizationsListQueryOptions = <TData = Awaited<ReturnType<typeof groupOrganizationsList>>, TError = unknown>(params?: GroupOrganizationsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupOrganizationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupOrganizationsList>>> = ({ signal }) => groupOrganizationsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupOrganizationsListQueryResult = NonNullable<Awaited<ReturnType<typeof groupOrganizationsList>>>
export type GroupOrganizationsListQueryError = unknown

export const useGroupOrganizationsList = <TData = Awaited<ReturnType<typeof groupOrganizationsList>>, TError = unknown>(
 params?: GroupOrganizationsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupOrganizationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupOrganizationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Cross-org Packaging aggregation table.
 */
export const groupPackagingList = (
    params?: GroupPackagingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupPackagingList>(
      {url: `/group/packaging/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupPackagingListQueryKey = (params?: GroupPackagingListParams,) => {
    return [`/group/packaging/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupPackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupPackagingList>>, TError = unknown>(params?: GroupPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupPackagingList>>> = ({ signal, pageParam }) => groupPackagingList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupPackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupPackagingList>>>
export type GroupPackagingListInfiniteQueryError = unknown

export const useGroupPackagingListInfinite = <TData = Awaited<ReturnType<typeof groupPackagingList>>, TError = unknown>(
 params?: GroupPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupPackagingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupPackagingListQueryOptions = <TData = Awaited<ReturnType<typeof groupPackagingList>>, TError = unknown>(params?: GroupPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupPackagingList>>> = ({ signal }) => groupPackagingList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupPackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof groupPackagingList>>>
export type GroupPackagingListQueryError = unknown

export const useGroupPackagingList = <TData = Awaited<ReturnType<typeof groupPackagingList>>, TError = unknown>(
 params?: GroupPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupPackagingListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List PCF products across the parent's selected child organizations.

Filters by `organizations` (no date filter — products are not period-bound).
Sorts by most-recently modified.
 */
export const groupProductsList = (
    params?: GroupProductsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupProductListList>(
      {url: `/group/products/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupProductsListQueryKey = (params?: GroupProductsListParams,) => {
    return [`/group/products/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupProductsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupProductsList>>, TError = unknown>(params?: GroupProductsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupProductsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupProductsList>>> = ({ signal, pageParam }) => groupProductsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupProductsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupProductsList>>>
export type GroupProductsListInfiniteQueryError = unknown

export const useGroupProductsListInfinite = <TData = Awaited<ReturnType<typeof groupProductsList>>, TError = unknown>(
 params?: GroupProductsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupProductsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupProductsListQueryOptions = <TData = Awaited<ReturnType<typeof groupProductsList>>, TError = unknown>(params?: GroupProductsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupProductsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupProductsList>>> = ({ signal }) => groupProductsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof groupProductsList>>>
export type GroupProductsListQueryError = unknown

export const useGroupProductsList = <TData = Awaited<ReturnType<typeof groupProductsList>>, TError = unknown>(
 params?: GroupProductsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Aggregated purchasing dashboard: totals, emissions time-series, per-org breakdown, and top-20 suppliers.
 */
export const groupPurchasesDashboardRetrieve = (
    params?: GroupPurchasesDashboardRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<GroupPurchasingDashboard>(
      {url: `/group/purchases-dashboard/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupPurchasesDashboardRetrieveQueryKey = (params?: GroupPurchasesDashboardRetrieveParams,) => {
    return [`/group/purchases-dashboard/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupPurchasesDashboardRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError = unknown>(params?: GroupPurchasesDashboardRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupPurchasesDashboardRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>> = ({ signal, pageParam }) => groupPurchasesDashboardRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupPurchasesDashboardRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>>
export type GroupPurchasesDashboardRetrieveInfiniteQueryError = unknown

export const useGroupPurchasesDashboardRetrieveInfinite = <TData = Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError = unknown>(
 params?: GroupPurchasesDashboardRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupPurchasesDashboardRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupPurchasesDashboardRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError = unknown>(params?: GroupPurchasesDashboardRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupPurchasesDashboardRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>> = ({ signal }) => groupPurchasesDashboardRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupPurchasesDashboardRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>>
export type GroupPurchasesDashboardRetrieveQueryError = unknown

export const useGroupPurchasesDashboardRetrieve = <TData = Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError = unknown>(
 params?: GroupPurchasesDashboardRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupPurchasesDashboardRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupPurchasesDashboardRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List users belonging to a specific child organisation.

Requires a mandatory `organization` query param (child org UUID). Returns
400 if the param is missing or malformed. Non-child org UUIDs return an
empty result. Supports `?search=` for case-insensitive name filtering.
 */
export const groupUsersList = (
    params?: GroupUsersListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedGroupUserList>(
      {url: `/group/users/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGroupUsersListQueryKey = (params?: GroupUsersListParams,) => {
    return [`/group/users/`, ...(params ? [params]: [])] as const;
    }

    
export const getGroupUsersListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof groupUsersList>>, TError = unknown>(params?: GroupUsersListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupUsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupUsersList>>> = ({ signal, pageParam }) => groupUsersList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupUsersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof groupUsersList>>>
export type GroupUsersListInfiniteQueryError = unknown

export const useGroupUsersListInfinite = <TData = Awaited<ReturnType<typeof groupUsersList>>, TError = unknown>(
 params?: GroupUsersListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupUsersListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupUsersListQueryOptions = <TData = Awaited<ReturnType<typeof groupUsersList>>, TError = unknown>(params?: GroupUsersListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupUsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupUsersList>>> = ({ signal }) => groupUsersList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData> & { queryKey: QueryKey }
}

export type GroupUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof groupUsersList>>>
export type GroupUsersListQueryError = unknown

export const useGroupUsersList = <TData = Awaited<ReturnType<typeof groupUsersList>>, TError = unknown>(
 params?: GroupUsersListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof groupUsersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGroupUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



